import { Col, Row } from "antd";
import { get, set } from "lodash";
import { useTranslation } from "react-i18next";
import Form from "shared/components/Form";
import FormField from "shared/components/FormField";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { RELATIONSHIP, SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import {
  BENEFICIARY_TYPE_OPTIONS,
  buildObsequesCoupleDisabled,
  isOtherBeneficiary,
} from "../../../obseques";

const Beneficiary = ({
  setPercent,
  isFieldRequired,
  initialValues,
  bindField,
  setDisabled,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  const typePath = "beneficiary.relationship";
  const designationPath = "beneficiary.identity.fields.designation";
  const typeField = bindField(typePath, {
    label: SUBSCRIPTION.FORM.BENEFICIARY_TYPE.LABEL,
    required: isFieldRequired(typePath),
    onChange: (value) => {
      set(initialValues, typePath, value);
      if (value !== RELATIONSHIP.OTHER) {
        set(initialValues, designationPath, "");
      }
      if (typeof setDisabled === "function") {
        const coupleDisabled = buildObsequesCoupleDisabled(initialValues);
        setDisabled((prev) => ({ ...prev, ...coupleDisabled }));
      }
      setPercent(initialValues);
    },
  });
  const designationField = bindField(designationPath, {
    label: SUBSCRIPTION.FORM.BENEFICIARY_DESIGNATION.LABEL,
    required:
      isOtherBeneficiary(initialValues) && isFieldRequired(designationPath),
    onBlur: () => setPercent(initialValues),
  });

  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.BENEFICIARY}-section`}
    >
      <Form
        type="vertical"
        title={SUBSCRIPTION.FORM.BENEFICIARY_TYPE.TITLE}
        subtitle={SUBSCRIPTION.FORM.BENEFICIARY_TYPE.SUBTITLE}
      >
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <FormField
              path={typeField.path}
              label={typeField.label}
              required={typeField.required}
              disabled={typeField.disabled}
            >
              {(field) => (
                <Input
                  type="radio"
                  variant="group"
                  values={BENEFICIARY_TYPE_OPTIONS}
                  label={typeField.label}
                  value={get(initialValues, typePath) || RELATIONSHIP.SPOUSE}
                  {...field}
                  onChange={typeField.onChange}
                  onBlur={typeField.onBlur}
                />
              )}
            </FormField>
          </Col>
          {isOtherBeneficiary(initialValues) && (
            <Col lg={24} xs={24}>
              <FormField
                path={designationField.path}
                label={designationField.label}
                required={designationField.required}
                disabled={designationField.disabled}
              >
                {(field) => (
                  <Input
                    type="textarea"
                    label={designationField.label}
                    placeholder={
                      SUBSCRIPTION.FORM.BENEFICIARY_DESIGNATION.PLACEHOLDER
                    }
                    defaultValue={designationField.defaultValue}
                    maxLength={300}
                    autoSize={{ minRows: 3, maxRows: 6 }}
                    {...field}
                    onChange={designationField.onChange}
                    onBlur={designationField.onBlur}
                  />
                )}
              </FormField>
            </Col>
          )}
        </Row>
      </Form>
    </div>
  );
};

export default Beneficiary;
